import React from "react";
import { Field } from "react-final-form";
import { CentsInput } from "../../../components/inputs/final_form/MoneyInput";
import { TextInput } from "../../../components/inputs/final_form/TextInput";
import { LoadingButton } from "../../../components/LoadingButton";
import { required } from "../../../util/validators";
import { AdministrateSelectInput, AdminOptionableInput } from "../../components/inputs/AdministrateSelectInput";

export const FeeScheduleByPlanTypeForm = ({ handleSubmit, submitting, create = true }) => {
  return (
    <>
      <Field component={TextInput} type="hidden" name="labId" />

      {create && (
        <>
          <Field
            component={AdminOptionableInput}
            resource="payors"
            label="Payor"
            name="payorId"
            searchParam="name"
            required
            validate={required}
          />
          <Field
            component={AdministrateSelectInput}
            resourceUrl="/admin/cpt_codes.json"
            label="CPT Code"
            name="cptCodeId"
            required
            validate={required}
          />
          <Field
            component={AdministrateSelectInput}
            resourceUrl="/admin/enums/plan_type_groups.json"
            label="Plan Type"
            name="planTypeGroup"
            required
            valueKey="id"
            labelKey="label"
            validate={required}
          />
        </>
      )}
      <Field component={CentsInput} label="Price" name="priceCents" />
      <LoadingButton loading={submitting} onClick={handleSubmit} disabled={submitting}>
        Submit
      </LoadingButton>
    </>
  );
};
